import SalviaLayout from "@/components/SalviaLayout";
import { SuggestionsMatrixTab } from "@/components/SuggestionsMatrixTab";
import { usePageTitle } from "@/hooks/usePageTitle";

export default function ERGOSSugestoes() {
  usePageTitle("Sugestões ERGOS");
  return (
    <SalviaLayout>
      <div className="container mx-auto py-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold">Sugestões ERGOS</h1>
          <p className="text-muted-foreground mt-2">
            Biblioteca versionada de recomendações para fatores psicossociais
          </p>
        </div>
        
        <SuggestionsMatrixTab />
      </div>
    </SalviaLayout>
  );
}
